<template>
  <div class="checkout-container-left">
    <div
      v-show="reviewIsOpen"
      class="review-purchase-container"
    >
      <h2>Review Purchase</h2>

      <div class="review-invoice-items-container">
        <div class="review-invoice-items-inner-container">
          <!-- Invoice Items -->
          <div
            v-for="invoiceItem in nonShippingInvoiceItems"
            :key="invoiceItem.invoice_item_id"
            style="width: 100%"
          >
            <div
              v-if="invoiceItem.inventory_id"
              class="review-invoice-item"
            >
              <div class="checkmark-container">
                <img
                  class="review-invoice-item-thumbnail"
                  :src="invoiceItem.image"
                >
                <p v-html="invoiceItem.description" />
              </div>

              <label>{{
                invoiceItem.display_total_charges.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}</label>
            </div>
          </div>

          <hr
            v-if="useArta"
            class="hr-design"
          >

          <!-- Selected Shipping Option -->
          <div
            v-if="
              useArta &&
                (selectedShippingOption !== null || selectedPickUp == true)
            "
            style="width: 100%"
          >
            <div class="selected-shipping-container">
              <div class="checkmark-container">
                <img
                  src="/assets/green_checkmark.png"
                  class="img-checkmark"
                >
                <label v-if="selectedPickUp == true">Pick Up</label>
                <label v-else-if="selectedShippingOption !== null">{{
                  selectedShippingOption.description
                }}</label>
                <label v-else />
              </div>

              <label v-if="selectedPickUp == true">$0.00</label>
              <label v-else-if="selectedShippingOption != null">{{
                selectedShippingOption.display_total_charges.toLocaleString(
                  undefined,
                  { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                )
              }}</label>
              <label v-else />
            </div>
            <hr
              v-if="useArta"
              class="hr-design"
            >
          </div>

          <div class="selected-tax">
            <label>Item Subtotal</label>
            <label>${{
              invoice
                ? (
                  invoice.invoice_buyers_total +
                  invoice.invoice_hammer_total
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
                : 0
            }}</label>
          </div>

          <div
            v-if="useArta"
            class="selected-tax"
          >
            <label>Shipping Subtotal</label>
            <label v-if="selectedShippingOption != null">{{
              selectedShippingOption.display_total_charges.toLocaleString(
                undefined,
                { minimumFractionDigits: 2, maximumFractionDigits: 2 }
              )
            }}</label>
            <label v-else>$0.00</label>
          </div>

          <div class="selected-tax">
            <label>Tax</label>
            <div
              v-if="isThinking"
              class="loading"
            />
            <label v-else>${{
              invoice
                ? invoice.invoice_tax_total.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
                : 0
            }}</label>
          </div>

          <div
            v-if="convenienceFee !== '' && convenienceFee !== '0' && convenienceFee !== '0.00' && convenienceFee !== undefined"
            class="selected-tax"
          >
            <label>*Convenience Fee 3%</label>
            <div
              v-if="isThinking"
              class="loading"
            />
            <label v-else>${{
              convenienceFee.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            }}</label>
          </div>

          <div
            v-if="invoicePayments && invoicePayments.length > 0"
            class="prepayment-container"
          >
            <hr class="hr-design">
            <p>Prepayments</p>
            <div
              v-for="payment in invoicePayments"
              :key="payment.invoice_payment_id"
              class="prepayment-item"
            >
              <label
                v-if="
                  payment.payment_type === 'existing_card' ||
                    payment.payment_type === 'new_card'
                "
              >{{ payment.date }} - {{ payment.cc_type }} ({{
                payment.cc_last_four
              }}) exp. {{ payment.cc_expire_month }}/{{
                payment.cc_expire_year
              }}</label>
              <label v-else>{{ payment.date }} - {{ payment.payment_type }}</label>
              <label>{{ payment.amount }}</label>
            </div>
            <div
              v-for="item in invoice.invoice_items"
              :key="item.invoice_item_id"
              class="prepayment-item"
            >
              <label v-if="item.convenience_fee === 'y' && item.description !== 'Convenience Fee'">{{ item.description }}</label>
              <label v-if="item.convenience_fee === 'y' && item.description !== 'Convenience Fee'">{{ item.display_total_charges }}</label>
            </div>
          </div>
        </div>

        <!-- Final total section -->
        <div class="final-total-container">
          <h2 v-if="invoice && invoice.payment_status == 'overpaid'">
            Credit Owed
          </h2>
          <h2 v-else-if="invoice && invoice.payment_status == 'unpaid'">
            Please Pay
          </h2>
          <h2 v-else>
            Balance
          </h2>
          <div
            v-if="isThinking"
            class="loading"
          />
          <h2
            v-else
            :class="
              invoice && invoice.payment_status == 'overpaid' ? 'overpaid' : ''
            "
          >
            ${{
              total.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            }}
          </h2>
        </div>
      </div>
    </div>
    <!-- Total Review Bar -->
    <TotalReviewBar
      v-if="invoice"
      :invoice="invoice"
      :review-is-open="reviewIsOpen"
      :toggle-review="toggleReview"
      :hide-total="true"
    />
  </div>
</template>

<script>
import apiMixin from '@/mixins/apiMixin.js'
import InvoiceValidateMixin from '@/mixins/InvoiceValidateMixin.js'
import TotalReviewBar from '../Shared/TotalReviewBar.vue'
/**
 * The Payment Info Checkout component.
 * TODO: refactor, clean up, and document how it works
 * @displayName Payment Info Component
 */
export default {
	name: 'PurchaseReviewComponent',
	components: {
		TotalReviewBar
	},
	mixins: [apiMixin, InvoiceValidateMixin],
	props: [
		'invoice',
		'invoicePayments',
		'total',
		'useArta',
		'isThinking',
		'nonShippingInvoiceItems',
		'selectedShippingOption',
		'selectedPickUp'
	],
	data: function () {
		return {
			reviewIsOpen: true
		}
	},
	computed: {
		convenienceFee: function () {
			let convenienceFee = ''

			if (this.invoice) {
				if (this.invoice) {
					const convenienceItems = this.invoice.invoice_items.filter(item => item.convenience_fee === 'y' && item.description === 'Convenience Fee')
					convenienceFee = convenienceItems.reduce((total, item) => total + parseFloat(item.total_charges), 0)
				}

				return `${convenienceFee.toFixed(2)}`
			}
		}
	},
	mounted () {},
	methods: {
		toggleReview: function () {
			this.reviewIsOpen = !this.reviewIsOpen
		}
	}
}
</script>
